<template>
  <iframe id="footer" :src="getConfig('VUE_APP_CUSTOMER_FOOTER_SRC')">
  </iframe>
</template>

<script>

export default {
  components: {
  },
  methods: {
    getConfig(configKey) {
      return process.env[configKey]
    }
  },
};
</script>

<style>
  #footer {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 101%;
  height: 75vh;
  margin: 0;
  border: none;
}

@media (min-width: 1600px) {
  #footer{
    height: 48vh;
  }
}

@media (width: 1024px) and (height: 1366px) {
  #footer{
    height: 41vh;
  }
}

@media (max-width: 768px){
  #footer {
    height: 116vh;
  }
}

@media (max-width: 414px) {
  #footer {
    height: 65vh;
  }
}

@media (max-width: 384px) {
  #footer {
    height: 77vh;
  }
}

@media (max-width: 375px) {
  #footer {
    height: 74vh;
  }
}

@media (max-width: 360px) {
  #footer {
    height: 77vh;
  }
}

@media (max-width: 320px) {
  #footer {
    height: 92vh;
    width: 21rem;
  } 
}

 @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    #footer {
     height: 90vh;
    }
  }
</style>